import { useEffect, useState } from "react";
import DetailHelp from "./helpers/detail";
import Navbar from "../layouts/nav";
import { Link, useLocation } from "react-router-dom";
import ReactPlayer from 'react-player/lazy';
import AliceCarousel from "react-alice-carousel";
import "react-alice-carousel/lib/alice-carousel.css"
import './details.css';
import ImageCarousel from "./detailsCarousel";
import DailyAudio from "./dailyAudio";



export default function Details(){

  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);
  const searchQuery = queryParams.get("q").toLowerCase();
  const [searchResult, setSearchResult] = useState('');
  const [isPageLoaded, setPageLoaded] = useState(false);

  const [next, setNext] = useState(0);
  const [nextImage, setNextImage] = useState(0);
  const [mainIndex, setMainIndex] = useState(0);
  const [items, setItems] = useState([]);
  const [images, setImages] = useState([]);
  const [sound, setSound] = useState([]);

  
  const animateButton = function(e) {

    e.preventDefault();
    //reset animation
    e.target.classList.remove('animate');
    
    e.target.classList.add('animate');
    setTimeout(function(){
      e.target.classList.remove('animate');
    },700);
  };
  
  const bubblyButtons = document.getElementsByClassName("bubbly-button");
  
  for (let i = 0; i < bubblyButtons.length; i++) {
    bubblyButtons[i].addEventListener('click', animateButton, false);
  }


    useEffect(() => {

        window.onload = () => {
            setTimeout(() => setPageLoaded(true), 1000);
          };

        if(searchQuery){
            fetch('https://biouniverse-api.vercel.app/search', {
                method: 'POST',
                body: JSON.stringify({searchQuery}),
                headers: {'Content-Type': 'application/json'},
            })
            .then(res => res.json())
            .then(data => {
              const videoItem = [];
              for(let item of data[next].videos.videoArray2){
                videoItem.push(
                  <div className="item">
                  <video width="100%" controls className="media">
                    <source src={`${item.videos.medium.url}`}/>
                    Your browser does not support the video tag.
                  </video>
                </div>
                );
              }
              if(videoItem.length === 0){
                videoItem.push(  <div className="item">
                <video width="100%" controls className="media">
                  <source src='https://player.vimeo.com/external/362720836.sd.mp4?s=39ea047c18b8ca33f4368dca40cc858330e67774&profile_id=164&oauth2_token_id=57447761'/>
                  Your browser does not support the video tag.
                </video>
              </div>)
              }

              const imagesData = [];
              for(const item of data[next].images.imageArray2){
                if(imagesData.length === 10) break;
                imagesData.push(item.images.medium);
              }
              for(const item of data[next].images.imageArray3){
                if(imagesData.length === 10) break;
                imagesData.push(item.images.small);
              }
              for(const item of data[next].images.imageArray){
                if(imagesData.length === 10) break;
                imagesData.push(item.webformatURL);
              }
            if(imagesData.length === 0){
                imagesData.push('https://e0.pxfuel.com/wallpapers/518/637/desktop-wallpaper-cute-sad-puppy-adorable-dog-thumbnail.jpg');
                imagesData.push('https://e0.pxfuel.com/wallpapers/813/495/desktop-wallpaper-animals-dog-muzzle-sadness-sight-opinion-bw-chb-puppy-sorrow-bulldog-thumbnail.jpg');

              }
                

              const soundData = [];
              if(data[next].sounds.length === 0){
                soundData.push({
                  id: 523755,
                name: "Item 01.wav",
                audio: {
                    "preview-hq-mp3": "https://cdn.freesound.org/previews/523/523755_6142149-hq.mp3",
                    "preview-hq-ogg": "https://cdn.freesound.org/previews/523/523755_6142149-hq.ogg",
                    "preview-lq-mp3": "https://cdn.freesound.org/previews/523/523755_6142149-lq.mp3",
                    "preview-lq-ogg": "https://cdn.freesound.org/previews/523/523755_6142149-lq.ogg"
                }})
                setSound(soundData)
              }else{

                for(const i of data[next].sounds){
                  if(soundData.length > 4){
                    break;
                  }
                  soundData.push(i);
                }
                setSound(soundData);
              }

              setImages(imagesData);
              setItems(videoItem);
                setSearchResult(data);
                // console.log('In Details ',data);
                // console.log('In Details 2 ',searchResult);
            })
            .catch(err => console.log(err));
        }
		// List of JS files to reload
		const jsFiles = [
		  // 'assets/js/scrolltoTop.js',
		  'assets/js/custom.js',
		];
	
		// Create script elements for each JS file
		jsFiles.forEach((filePath) => {
		  const script = document.createElement('script');
		  script.src = filePath;
		  script.async = true;
		  document.body.appendChild(script);
		});
	
		// Clean up the script elements when the component unmounts
		return () => {
		  jsFiles.forEach((filePath) => {
			const script = document.querySelector(`[src="${filePath}"]`);
			if (script) {
			  document.body.removeChild(script);
			}
		  });
		};
	  }, []);


    const slideNext = () => {
      if (mainIndex < items.length - 1) {
        setMainIndex(mainIndex + 1);
      }
      if(mainIndex === items.length -1){
        setMainIndex(0);
      }
    };
  
    const slidePrev = () => {
      if (mainIndex > 0) {
        setMainIndex(mainIndex - 1);
      }
      if(mainIndex === 0){
        setMainIndex(items.length-1);
      }
    };
  




    return(
        <div>

<div>
		<div className="firefly"></div>
		<div className="firefly"></div>
		<div className="firefly"></div>
		<div className="firefly"></div>
		<div className="firefly"></div>
		<div className="firefly"></div>
		<div className="firefly"></div>
		<div className="firefly"></div>
		<div className="firefly"></div>
		<div className="firefly"></div>
		<div className="firefly"></div>
		<div className="firefly"></div>
		<div className="firefly"></div>
		<div className="firefly"></div>
		<div className="firefly"></div>
		<div className="firefly"></div>
		<div className="firefly"></div>
		<div className="firefly"></div>
		<div className="firefly"></div>
		<div className="firefly"></div>
		</div>
	


        <Navbar active={'dropdown'} transparent={'transparent'}/>
        <div className="detail_body">
  {searchResult ? (
    <>
      <section className="detail_section detail_sec-01">
        <div className="detail_container">
          <h2 className="detail_main-title">{searchResult[next].data.name}</h2>
          <div className="detail_content">
            <div className="detail_image">
              
              <ImageCarousel images={images} />
            </div>
            <div className="detail_text-box">
              <h3>{searchResult[next].data.characteristics.diet}</h3>
              <p><span style={{backgroundColor: 'black'}}>● Habitat:</span> {searchResult[next].data.characteristics.habitat}<br/><span style={{backgroundColor: 'black'}}>● About:</span> {searchResult[next].data.characteristics.slogan}<br/><span style={{backgroundColor: 'black'}}>● Weight:</span> {searchResult[next].data.characteristics.weight}</p>
            </div>
          </div>
          <div className="detail_media-icons">
            <div className="detail_country">
                {searchResult[next].data.locations &&
                     searchResult[next].data.locations.map((country, index) => (
                        <div key={index}>● {country}</div>
                ))}
            </div>
        </div>

        </div>
      </section>

      <section className="detail_section detail_sec-02">
        <div className="detail_container">
          <h3 className="detail_section-title">{searchResult.section2Title}</h3>
          <div className="detail_content">
            <div className="detail_image">
            <ImageCarousel images={images.slice(Math.ceil(images.length / 2))} />

            </div>
            <div className="detail_info">
              <h4 className="detail_info-title">Description</h4>
              <table>
                <colgroup>
                  <col style={{ width: '40%' }} />
                  <col style={{ width: '50%' }} />
                </colgroup>
                <tbody>
                  {Object.entries(searchResult[next].data.characteristics).map(([key, value], index) => (
                    <tr key={index} style={{ height: '30px' }}>
                      <td>{key}</td>
                      <td>{value}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <p style={{marginTop: '20px'}}><span style={{backgroundColor: 'black', fontSize: '1.2rem'}}>Taxonomy:</span><br/></p>
            
              <table style={{ marginTop: '20px' }}>
              <colgroup>
                  <col style={{ width: '40%' }} />
                  <col style={{ width: '50%' }} />
                </colgroup>
                <tbody>
                  <tr>
                    <td>● Class</td>
                    <td>{searchResult[next].data.taxonomy.class}</td>
                  </tr>
                  <tr>
                    <td>● Family</td>
                    <td>{searchResult[next].data.taxonomy.family}</td>
                  </tr>
                  <tr>
                    <td>● Genus</td>
                    <td>{searchResult[next].data.taxonomy.genus}</td>
                  </tr>
                  <tr>
                    <td>● Kingdom</td>
                    <td>{searchResult[next].data.taxonomy.kingdom}</td>
                  </tr>
                  <tr>
                    <td>● Order</td>
                    <td>{searchResult[next].data.taxonomy.order}</td>
                  </tr>
                  <tr>
                    <td>● Phylum</td>
                    <td>{searchResult[next].data.taxonomy.phylum}</td>
                  </tr>
                  <tr>
                    <td>● Scientific Name</td>
                    <td>{searchResult[next].data.taxonomy.scientific_name}</td>
                  </tr>
                </tbody>
              </table>

            </div>
          </div>
        </div>
      </section>

      <section className="detail_section detail_sec-03">
        <div className="detail_container detail_container3">
          <h3 className="detail_section-title">Audios & Videos</h3>
          <div className="detail_content detail_content3">
            <div className="detail_media-info">
              <DailyAudio sound={sound} />
            </div>
            <div className="detail_image">
            

  <div className="carousel">
      <AliceCarousel
        activeIndex={mainIndex}
        disableDotsControls
        disableButtonsControls
        items={items}
      />
      <p className="index">{`${mainIndex + 1}/${items.length}`}</p>
      <div className="caption-container">

      </div>

      <div className="btn-prev" onClick={slidePrev}>
        &lang;
      </div>
      <div className="btn-next" onClick={slideNext}>
        &rang;
      </div>
    </div>

   

            </div>
            

	</div>
  
          </div>
      
      </section>
          <hr style={{ border: 'solid 2px white', marginBottom: '4rem' }}></hr>
      <div className="country_jungle_main-article" style={{ minHeight: 'auto', paddingBottom: '50px' }}>
        <div className="country_jungle_copy" style={{ fontSize: '1rem' }}>© BioUniverse -Vishal</div>
      </div>
      
    
    </>
  ) : (
    <div style={{width: '100vw', height: '100vh', zIndex: '-10', backgroundColor: '#020004'}}>
      <div style={{position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)'}}>
        <img src="https://i.gifer.com/4P4X.gif"/>
      </div>
    </div>
  )}
</div>
<div>
      {isPageLoaded ? <DetailHelp /> : ''}
    </div>
        </div>
    )
}
